import * as less from './App.less';
import React from 'react';
import flux from '../flux';
import { RouteHandler, Link } from 'react-router';
import FluxComponent from 'flummox/component';
import RadioPlayer from '../components/RadioPlayer';

export default class App extends React.Component {
  componentDidMount() {
    flux.getActions('playlist').load();
  }

  render() {
    return (
      <div className='outer-container'>
        <FluxComponent flux={flux} connectToStores={{
          playlist: store => ({ playlist: store.state.immutable })
        }}>
          <RouteHandler actions={flux.getActions('playlist')} />

          <RadioPlayer actions={flux.getActions('playlist')} />
        </FluxComponent>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/routes/App.jsx
 **/